import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import SearchRequest from "../../magData/Flight/SearchRequest";
import SearchResponse from "../../magData/Flight/SearchResponse";

function FlightSearchPage(props) {

  return (
    <>

      <Container fluid >
        <Row>
          <Col sm={12} >
            <p className="page-title">Flight Search Method</p>
          </Col>
          <Col sm={12} >
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/flight/search</p>
          </Col>
          <Col sm={12} >
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} >
            <p>Body Parameters</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>flightSteps</td>
                  <td>Origin and Destination details</td>
                  <td>Collection </td>
                  <td></td>
                </tr>
                <tr >
                  <td colSpan={4}> <Table bordered>
                    <tbody>
                      <tr>
                        <td>originCode</td>
                        <td>originCode Airport Code</td>
                        <td>string </td>
                        <td> <Badge bg="warning" text="dark">
                          Required
                        </Badge></td>
                      </tr>
                      <tr>
                        <td>destinationCode</td>
                        <td>Destination Airport Code</td>
                        <td>string </td>
                        <td> <Badge bg="warning" text="dark">
                          Required
                        </Badge></td>
                      </tr>
                      <tr>
                        <td>departureDate</td>
                        <td>Departure Date and Time</td>
                        <td>string </td>
                        <td> <Badge bg="warning" text="dark">
                          Required
                        </Badge></td>
                      </tr>
                    </tbody></Table></td>

                </tr>
                <tr>
                  <td  >searchedPassenger</td>
                  <td>Number of Passengers</td>
                  <td>Object </td>
                  <td></td>
                </tr>
                <tr >
                  <td colSpan={4}> <Table bordered>
                    <tbody>
                      <tr>
                        <td>adt</td>
                        <td>Number of Adults</td>
                        <td>integer </td>
                        <td> <Badge bg="warning" text="dark">
                          Required
                        </Badge></td>
                      </tr>
                      <tr>
                        <td>inf</td>
                        <td>	Number of Infants</td>
                        <td>integer </td>
                        <td> <Badge bg="warning" text="dark">
                          Required
                        </Badge></td>
                      </tr>
                      <tr>
                        <td>chd</td>
                        <td>Number of Childs</td>
                        <td>integer </td>
                        <td> <Badge bg="warning" text="dark">
                          Required
                        </Badge></td>
                      </tr>
                    </tbody></Table></td>
                </tr>
                <tr>
                  <td>flightPreferences</td>
                  <td >Details of your request</td>
                  <td>Object </td>
                  <td> </td>
                </tr>
                <tr >
                  <td colSpan={4}> <Table bordered>
                    <tbody>
                      <tr>
                        <td>cabinClass</td>
                        <td>Cabin Type</td>
                        <td>integer </td>
                        <td> <p> <Badge bg="warning" text="dark">
                          Required
                        </Badge></p>
                          <p>Economy - Y = 1</p>
                          <p>Premium Economy - S = 2</p>
                          <p>Business - C = 3</p>
                          <p>Premium Business - J = 4</p>
                          <p>First - F = 5</p>
                          <p>Premium First - P = 6</p>
                          <p>Default  = 100</p>
                        </td>
                      </tr>
                      <tr>
                        <td>tripType</td>
                        <td>Trip Type</td>
                        <td>integer </td>
                        <td>
                          <p> <Badge bg="warning" text="dark">
                            Required
                          </Badge></p>
                          <p>1 : One Way </p>
                          <p>2 : Round Trip</p>
                        </td>
                      </tr>

                    </tbody></Table></td>

                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(SearchRequest, null, 2)}
            </pre>


          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12} >
            <p>Response Information</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>searchKey</td>
                  <td>Requset Unique Id</td>
                  <td>Collection </td>
                  <td></td>
                </tr>
                <tr>
                  <td>pricedItineraries</td>
                  <td>PricedItinerary Of Flight</td>
                  <td>Collection </td>
                  <td></td>
                </tr>
                <tr >
                  <td colSpan={4}> <Table bordered>
                    <tbody>
                      <tr>
                        <td>isPassportMandatory</td>
                        <td>Mandatory information</td>
                        <td>boolean</td>
                        <td> N</td>
                      </tr>

                      <tr>
                        <td>isPassportIssueDateMandatory</td>
                        <td>Mandatory information</td>
                        <td>boolean</td>
                        <td> N</td>
                      </tr>


                      <tr>
                        <td>directionInd</td>
                        <td>Trip Type</td>
                        <td>integer </td>
                        <td><p>1 : One Way </p>
                          <p>2 : Round Trip</p>
                        </td>
                      </tr>

                      <tr>
                        <td>refundMethod</td>
                        <td>Refund Method</td>
                        <td>integer </td>
                        <td><p>0 : Offline </p>
                          <p>1 : Online</p>
                          <p>2 : NonRefundable</p>
                        </td>
                      </tr>
                      <tr>
                        <td>validatingAirlineCode</td>
                        <td>Airline Code</td>
                        <td>String </td>
                        <td> </td>
                      </tr>

                      <tr>
                        <td>gdsRefrenceID</td>
                        <td>Refrence</td>
                        <td>String</td>
                        <td> </td>
                      </tr>
                      <tr>
                        <td>airItineraryPricingInfo</td>
                        <td>Air Itinerary Pricing Info</td>
                        <td>Object</td>
                        <td> </td>
                      </tr>
                      <tr >
                        <td colSpan={4}> <Table striped bordered>
                          <tbody>
                            <tr>
                              <td>fareType</td>
                              <td>fare Type</td>
                              <td>integer</td>
                              <td> <p>Default - 1 - Default</p>
                                <p>Publish - 2 - Publish</p>
                                <p>Private - 3 - Private</p>
                                <p>WebFare - 4 - Instant Purchase, doesn't allow to reserve and will issue by calling Airbook</p> </td>
                            </tr>
                            <tr>
                              <td>itinTotalFare</td>
                              <td> Fare Calculation</td>
                              <td>Object</td>
                              <td> </td>
                            </tr>
                            <tr >
                              <td colSpan={4}> <Table bordered>
                                <tbody>
                                  <tr>
                                    <td>baseFare</td>
                                    <td>Base Fare</td>
                                    <td>decimal </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>totalFare</td>
                                    <td>Total Fare</td>
                                    <td>decimal </td>
                                    <td></td>
                                  </tr> <tr>
                                    <td>totalTax</td>
                                    <td>Total Tax</td>
                                    <td>decimal </td>
                                    <td></td>
                                  </tr><tr>
                                    <td>currency</td>
                                    <td>Currency</td>
                                    <td>string </td>
                                    <td></td>
                                  </tr>
                                </tbody></Table></td>

                            </tr>

                            <tr>
                              <td>ptcFareBreakdown</td>
                              <td>Fare Break Down by Passenger Type Code</td>
                              <td>Collection</td>
                              <td> </td>
                            </tr>
                            <tr >
                              <td colSpan={4}> <Table bordered>
                                <tbody>
                                  <tr>
                                    <td>passengerFare</td>
                                    <td>Passenger Fare</td>
                                    <td>Object</td>
                                    <td></td>
                                  </tr>
                                  <tr >
                                    <td colSpan={4}> <Table bordered>
                                      <tbody>
                                        <tr>
                                          <td>BaseFare</td>
                                          <td>Base Fare</td>
                                          <td>decimal</td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td>TotalFare</td>
                                          <td>Total Fare</td>
                                          <td>decimal</td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td>Taxes</td>
                                          <td>Taxes</td>
                                          <td>Collection</td>
                                          <td></td>
                                        </tr>
                                        <tr >
                                          <td colSpan={4}> <Table bordered>
                                            <tbody>
                                              <tr>
                                                <td>name</td>
                                                <td>Name Of Tax</td>
                                                <td>string </td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td>amount</td>
                                                <td>Amount Of Tax</td>
                                                <td>decimal </td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td>currency</td>
                                                <td>Currency</td>
                                                <td>string </td>
                                                <td></td>
                                              </tr>
                                            </tbody></Table></td>

                                        </tr>
                                        <tr>
                                          <td>currency</td>
                                          <td>Currency</td>
                                          <td>string </td>
                                          <td></td>
                                        </tr>
                                      </tbody></Table></td>
                                  </tr>
                                  <tr>
                                    <td>passengerTypeQuantity</td>
                                    <td>Passenger Type Quantity</td>
                                    <td>Object </td>
                                    <td></td>
                                  </tr>
                                </tbody></Table></td>

                            </tr>
                            <tr >
                              <td colSpan={4}> <Table bordered>
                                <tbody>
                                  <tr>
                                    <td>passengerType</td>
                                    <td>Passenger Type</td>
                                    <td>integer </td>
                                    <td>
                                      <p>1=Adult</p>
                                      <p>2=Child</p>
                                      <p>3=Infant</p>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>quantity</td>
                                    <td>Quantity</td>
                                    <td>integer </td>
                                    <td></td>
                                  </tr>
                                </tbody></Table></td>

                            </tr>
                            <tr>
                              <td>fareInfoes</td>
                              <td></td>
                              <td>Array Of String</td>
                              <td> </td>
                            </tr>
                          </tbody></Table></td>
                      </tr>

                      <tr>
                        <td>originDestinationOptions</td>
                        <td>Origin Destination Options</td>
                        <td>Collection</td>
                        <td> </td>
                      </tr>
                      <tr >
                        <td colSpan={4}> <Table bordered>
                          <tbody>
                            <tr>
                              <td>journeyDurationPerMinute</td>
                              <td>	Journey Duration Per Minute</td>
                              <td>integer </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>connectionTimePerMinute</td>
                              <td>	Connection Time Per Minute</td>
                              <td>integer </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>flightSegments</td>
                              <td>Flight Segments</td>
                              <td>Collection </td>
                              <td></td>
                            </tr>
                            <tr >
                              <td colSpan={4}> <Table bordered>
                                <tbody>
                                  <tr>
                                    <td>departureDateTime</td>
                                    <td>Departure Date and Time</td>
                                    <td>date</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>arrivalDateTime</td>
                                    <td>Arrival Date and Time</td>
                                    <td>date</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>stopQuantity</td>
                                    <td>Number of stop per segment</td>
                                    <td>integer </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>resBookDesigCode</td>
                                    <td>Reservation Booking Designator Code</td>
                                    <td>string </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>journeyDuration</td>
                                    <td>Journey Duration</td>
                                    <td>string </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>journeyDurationPerMinute</td>
                                    <td>Journey Duration Per Minute</td>
                                    <td>integer </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>connectionTimePerMinute</td>
                                    <td>Connection Time Per Minute</td>
                                    <td>integer </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>departureAirportLocationCode</td>
                                    <td>Departure Airport Code</td>
                                    <td>string </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>arrivalAirportLocationCode</td>
                                    <td>Arrival Airport Code</td>
                                    <td>string </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>marketingAirlineCode</td>
                                    <td>Marketing Carrier</td>
                                    <td>string </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>cabinClassCode</td>
                                    <td>Cabin Class Code</td>
                                    <td>string</td>
                                    <td>Y - S - C - J - F - P </td>
                                  </tr>
                                  <tr>
                                    <td>cabinClassCodeName</td>
                                    <td>Cabin Class Name</td>
                                    <td>string</td>
                                    <td> Economy-Premium Economy-Business-Premium Business-First-Premium First</td>
                                   
                                  </tr>
                                  <tr>
                                    <td>operatingAirline</td>
                                    <td>Operating Carrier</td>
                                    <td>Object </td>
                                    <td></td>
                                  </tr>
                                  <tr >
                                    <td colSpan={4}> <Table bordered>
                                      <tbody>
                                        <tr>
                                          <td>code</td>
                                          <td>Operating Carrier Code</td>
                                          <td>string </td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td>flightNumber</td>
                                          <td>Flight Number</td>
                                          <td>string </td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td>equipment</td>
                                          <td>Flight Equipment</td>
                                          <td>string </td>
                                          <td></td>
                                        </tr>
                                      </tbody></Table></td>

                                  </tr>
                                  <tr>
                                    <td>seatsRemaining</td>
                                    <td>Seats Remaining if Available</td>
                                    <td>integer </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>isCharter</td>
                                    <td>Specify if flight is Charter</td>
                                    <td>boolean </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>isReturn</td>
                                    <td>Specify if return Segment</td>
                                    <td>boolean </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>baggages</td>
                                    <td>Baggage</td>
                                    <td>Array Of string</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>policyRules</td>
                                    <td>Policy Rules</td>
                                    <td>object </td>
                                    <td></td>
                                  </tr>
                                  <tr >
                                    <td colSpan={4}> <Table bordered>
                                      <tbody>
                                        <tr>
                                          <td>name</td>
                                          <td></td>
                                          <td>string </td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td>date</td>
                                          <td></td>
                                          <td>date </td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td>description</td>
                                          <td></td>
                                          <td>string </td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td>percent</td>
                                          <td></td>
                                          <td>integer </td>
                                          <td></td>
                                        </tr>
                                      </tbody></Table></td>

                                  </tr>
                                  <tr>
                                    <td>technicalStops</td>
                                    <td>Technical Stop</td>
                                    <td>object</td>
                                    <td></td>
                                  </tr>
                                  <tr >
                                    <td colSpan={4}> <Table bordered>
                                      <tbody>
                                        <tr>
                                          <td>arrivalAirport</td>
                                          <td>Arrival Airport Code</td>
                                          <td>string </td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td>arrivalDateTime</td>
                                          <td>Arrival Date and Time</td>
                                          <td>date </td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td>departureDateTime</td>
                                          <td>Departure Date and Time</td>
                                          <td>date </td>
                                          <td></td>
                                        </tr>
                                      </tbody></Table></td>

                                  </tr>
                                </tbody></Table></td>

                            </tr>
                          </tbody></Table></td>
                      </tr>
                    </tbody></Table></td>
                </tr>



              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(SearchResponse, null, 2)}
            </pre>


          </Col>
        </Row>
      </Container>

    </>
  );
}

export default FlightSearchPage;